import { useWebSettingsModel } from '@entities/common';

export const useWebSettings = () => {
	const { webSettings } = useWebSettingsModel();
	return {
		...webSettings,
	};
};
